"use client"

import { GraduationCap, FileText, Images, CalendarDays } from "lucide-react"

export function WhyChooseUs() {
  const items = [
    {
      icon: GraduationCap,
      title: "Special Program",
      desc: "Our curriculum is designed to challenge and inspire. We offer specialized programs for students demonstrating exceptional academic potential, fostering intellectual curiosity and critical thinking through rigorous coursework and mentorship."
    },
    {
      icon: FileText,
      title: "Admission Details",
      desc: "Admissions open in December/January for the upcoming academic year. Please visit our website for the latest notifications, registration forms, and detailed guidelines on the application process."
    },
    {
      icon: Images,
      title: "Gallery",
      desc: "Explore our vibrant campus life through our gallery. From academic achievements to cultural celebrations, these captured moments reflect the joy, spirit, and community that define our school."
    },
    {
      icon: CalendarDays,
      title: "Events Details",
      desc: "Life at our school is a dynamic blend of academics and co-curriculars. We regularly organize cultural festivals, science exhibitions, sports competitions, and class presentations to nurture holistic growth."
    }
  ]

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-[#002855] via-[#003366] to-[#002855] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid gap-6 sm:gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 max-w-7xl mx-auto">
          {items.map(({ icon: Icon, title, desc }, index) => (
            <article
              key={title}
              className="group relative h-full bg-white/95 hover:bg-white backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-white/10 animate-slide-in-left"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl" />

              <div className="relative z-10 flex flex-col items-start h-full">
                <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#002855] text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7" strokeWidth={1.5} />
                </div>

                <h3 className="text-xl font-bold text-[#002855] mb-3 font-serif tracking-wide group-hover:text-blue-700 transition-colors">
                  {title}
                </h3>

                <p className="text-sm sm:text-base text-slate-600 leading-relaxed text-pretty">
                  {desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
